/**
 * @author: lv.chen
 * @date: 2025/12/30
 * @desc: 小游戏榜单Top3公共组件
 */
import React from 'react';
import classnames from 'classnames';
import EllipsisHover from '@home/components/EllipsisHover';
import GameImage from '@home/components/GameImage';
import RankChange from '../RankChange';
import { isEmpty } from '@intelligence/v3/utils/common';
import { formatCasualDailyReportDate, getRankElement, renderChangeTag } from '../../utils';

interface IRanksTop3BaseProps extends IBaseProps {
  /** 榜单标题 */
  title: string;
  /** 图标alt描述 */
  iconAlt: string;
  /** 平台图标 */
  platformIcon: string;
  /** 第一榜单标题 */
  firstRankTitle: string;
  /** 第一榜单样式class */
  firstRankClass?: string;
  /** 第二榜单标题 */
  secondRankTitle: string;
  /** 第二榜单样式class */
  secondRankClass?: string;
  /** 榜单数据日期 */
  date?: string;
  /** 人气榜Top3数据 */
  popularityTopRanks?: IMiniGameRankItem[] | null;
  /** 第二榜单Top3数据 */
  secondTopRanks?: IMiniGameRankItem[] | null;
}

const RanksTop3MiniGame: React.FC<IRanksTop3BaseProps> = (props) => {
  const {
    title,
    iconAlt,
    platformIcon,
    firstRankTitle,
    firstRankClass,
    secondRankTitle,
    secondRankClass,
    date,
    popularityTopRanks,
    secondTopRanks,
  } = props;

  // 任一榜单有数据时才显示
  const hasData = !isEmpty(popularityTopRanks) || !isEmpty(secondTopRanks);

  // 渲染榜单项
  const renderRankItem = (item: IMiniGameRankItem, index: number) => {
    const { app_name: appName, app_cover: appCover, publisher, tag, tag_desc: tagDesc } = item || {};
    return (
      <div key={appName} className="dbi-rank-card">
        <div className="dbi-rank-card-index">{getRankElement(index)}</div>
        <div className="dbi-rank-card-info">
          <div className="dbi-rank-card-info-avatar">
            <GameImage entityType="mobile" src={appCover} />
          </div>
          <div className="dbi-rank-card-info-text">
            <div className="dbi-rank-card-info-title">{appName}</div>
            <div className="dbi-rank-card-info-desc">
              <EllipsisHover text={publisher} />
            </div>
          </div>
        </div>
        <div className="dbi-rank-card-info-trend">
          <div className="dbi-rank-info-trend-percent">
            <RankChange data={item?.rank_change} />
            {renderChangeTag(tag, tagDesc)}
          </div>
        </div>
      </div>
    );
  };

  if (!hasData) {
    return null;
  }
  return (
    <div className="dbi-section-rank-content dbi-section-rank--app">
      <div className="dbi-section-rank-date">榜单数据日期：{date ? formatCasualDailyReportDate(date) : '-'}</div>
      <div className="dbi-section-rank-box">
        <div className="dbi-section-rank-box-wrap">
          <div className="dbi-section-rank-box-hd">
            <div className="dbi-section-rank-box-hd-title">
              <img className="dbi-section-production-title-img" src={platformIcon} alt={iconAlt} />
              <span>{title}</span>
            </div>
            <div className="dbi-section-rank-box-hd-desc">
              <p className="dbi-rank-card-country">排名变化</p>
            </div>
          </div>
          <div className="dbi-section-rank-box-bd">
            {!isEmpty(popularityTopRanks) && (
              <>
                <div className={classnames('section-rank-bill-title', firstRankClass)}>{firstRankTitle}</div>
                {popularityTopRanks?.map((item, index) => renderRankItem(item, index))}
              </>
            )}
            {!isEmpty(secondTopRanks) && (
              <>
                <div className={classnames('section-rank-bill-title', secondRankClass)}>{secondRankTitle}</div>
                {secondTopRanks?.map((item, index) => renderRankItem(item, index))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RanksTop3MiniGame;
